import React, { useEffect, useState, useRef } from 'react'
import { useAuth, hasAuthParams } from 'react-oidc-context'
import classNames from 'classnames'
import partnerConfig from '@alias-current-partner-customizations';

import {
  UniImg,
  IUniToast_Alert, 
  EMessageType,
  UniConditionalRender,
  UniLoader,
  withRouteMatchParams,
  IRouteMatchParamsHOCProps,
} from '@unikey/unikey-commons/release/comm';

import {
  ENavPages,
  devLogger,
  mockAuth,
  addAlert,
  partnerKey,
  redirectToLogin,
  useAppDispatch,
  checkValidAuthentication,

  addPendingRedirect,
  PartnerCustomizations,
  IPartnerCustomizations,
  navConfig,
} from '../internal';

interface IProps extends IPartnerCustomizations, IRouteMatchParamsHOCProps {
  match: any,
  history: any,
  darkModeActive: boolean,
  withLoader?: boolean,
  hideLogo?: boolean,
  externalRedirect?: boolean,
  fromComponentName?: string,
  addAlert(config: IUniToast_Alert): void,
  redirectToLogin(): void,
  ensureAuthenticatedAndVerified(): any
}

const SplashContainer: React.FC<IProps> = (props) => {

  const dispatch = useAppDispatch();
  const auth = useAuth();
  const [hasTriedSignin, setHasTriedSignin] = React.useState(false);

  const splashHangRedirectRef = useRef<NodeJS.Timeout | null>(null);
  const finalSplashHangRedirectRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    // // as long as we are not expecting the redirect to happen from another source, 
    // // then go ahead and make request to redirect appropriately
    // if (!props.externalRedirect && !mockAuth) {
    //   // see if we are authenticated still, then 
    //   // redirect to portalLanding, login, verify, or otherwise
    //   const validAuth = dispatch(checkValidAuthentication?.());
    //   const hasAPs = hasAuthParams();

    //   if (!validAuth 
    //     &&
    //     !hasAPs 
    //     &&
    //     // !auth.isAuthenticated && 
    //     // !auth.activeNavigator && 
    //     !auth.isLoading 
    //     // &&
    //     // !hasTriedSignin
    //   ) {
    //     dispatch(redirectToLogin())
    //   } 
    // }

    if (props.doesMatchPath('/')) {
      // this is the catch-all route which just shows a splash container, 
      // if so, bump to the portal since they're on the wrong route.
      dispatch(addPendingRedirect({
        pathname: navConfig.get(ENavPages.portalLanding)!.linkTo([]),
        delay: 400
      }));
    }
    

    // TODO: there is a "UserManager.getUser() user not found" message logged 
    // to console sometimes. When this happens, it causes this splash screen to hang.
    // Nothing is exposed to hook into that currently, but we need to investigate 
    // a way to redirect directly when the oidc library's user is not found vs 
    // using the fallback below to redirect after an extended wait.

    // fallback to not hang on splash screen for too long. 
    // force back to login if waiting for > 10 seconds
    splashHangRedirectRef.current = setTimeout(() => {
      devLogger("Splash duration longer than expected.");
      
      // display redirecting now message to the user.
      dispatch(addAlert({
        id: Date.now(),
        type: EMessageType.warn,
        titleKey: 'onSplashTooLogin',
        messageKeys: ['sendingToLogin']
      }))

      // after 3+ more seconds, give up and redirect the user to login
      finalSplashHangRedirectRef.current = setTimeout(() => dispatch(redirectToLogin()), 5000);
    }, 8000);

    // on unmount
    return () => {
      if (finalSplashHangRedirectRef?.current) clearTimeout(finalSplashHangRedirectRef?.current);
      if (splashHangRedirectRef?.current) clearTimeout(splashHangRedirectRef?.current);
    }
  }, [auth, hasTriedSignin])

  const imgClassName = classNames('partner-logo', 'splash', {
    [partnerKey]: true
  });

  return (
    <>
    {/* TODO restore loader for case when custom partner branding is used and we dont want to show a branded splash screen */}
      <UniConditionalRender visible={!props.hideLogo}>
          <UniImg textKey="partner logo"
            className={classNames('partner-logo', 'splash', partnerKey)}
            src={props.darkModeActive ? partnerConfig.assets.logoOnDark : partnerConfig.assets.logoOnBackground} />
        </UniConditionalRender>
        <UniConditionalRender visible={props.withLoader}>
          <div className="splash-loader splash">
            <UniLoader type="radial" />
          </div>
        </UniConditionalRender>
    </>
  )
}

export default PartnerCustomizations(
  withRouteMatchParams(SplashContainer), {
    componentName: 'Splash'
  }
)
